import { FC, ReactNode } from 'react';
import styles from './base-message.module.scss';
import { ThreadMessageAuthor } from '@/models/thread';
import SourcesIcon from '@/assets/icons/database.svg?react';

import { truncateText } from '@/utils/functions';
import useSession from '@/hooks/useSession';
import useItem from '@/pages/Thread/hooks/useItem';
import IconHeading from '../../IconHeading';
import SourceIndicator from '../../SourceIndicator';
import Options from '../Options';
import useThread from '@/pages/Thread/hooks/useThread';

interface BaseMessageProps {
  author: ThreadMessageAuthor;
  children: ReactNode;
}

const BaseMessage: FC<BaseMessageProps> = ({ author, children }) => {
  const { pushUserEvent } = useSession();
  const { status } = useThread();
  const { item: block, isLast } = useItem();
  const { sources } = block;

  return (
    <div
      data-testid={`msg-${author}`}
      className={`${styles.message} ${
        author === 'USER' ? styles['user-message'] : styles['assistant-message']
      }`}
      data-loading={
        author === 'USER' ? null : !!(isLast && status === 'FETCHING')
      }
    >
      <div className={styles['message-content']}>{children}</div>
      {author === 'ASSISTANT' && (
        <>
          {(!isLast || status === 'READY' || status === 'CITING') &&
            sources &&
            sources.length > 0 && (
              <div className={styles['message-sources']}>
                <IconHeading>
                  <SourcesIcon /> Sources ({sources.length})
                </IconHeading>
                <ul>
                  {sources?.map(({ url, title }, i) => {
                    const truncatedTitle = truncateText(title, 60);
                    return (
                      <li key={i}>
                        <div>
                          <SourceIndicator id={i + 1} />
                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                              pushUserEvent('click_response_source');
                            }}
                          >
                            {truncatedTitle}
                          </a>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          <Options />
        </>
      )}
    </div>
  );
};

export default BaseMessage;
